import { Component } from '@angular/core';
// import { MessagingService } from './services/messaging.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'app';
  //message;

  constructor() { }

  ngOnInit() {
    // this.messagingService.getPermission();
    // this.messagingService.receiveMessage();
    // this.message = this.messagingService.currentMessage;
  }
}
